module.exports = __webpack_public_path__ + "img/19.2d1c7072.jpg";